import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Image from "antd/lib/image";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import CarouselWidgetMaker from "./Carousel";
import Profile from "../../assets/Profile_Pic.svg";
import fx from "../../assets/WidgetMaker/FX.svg";
import InfoIcon from "../../assets/Info_Icon.svg";
import InfoIconYellow from "../../assets/Info_Icon_Yellow.svg";
import BoostedPostIcon from "../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../assets/ads_post_icon.svg";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import Default_Brand from "../../assets/brandLogos/Default_Brand.svg";
import userFollowers from "../../assets/FollowersBlue.svg";
import ClockIcon from "../../assets/Clock.svg";
import CustomizedIcon from "../../assets/Customize_icon.svg";
import verified from "../../assets/verified.svg";
import somethingWentWrong from "../../assets/No_Data_Found.svg";
import NoDataImg from "../../assets/no-data-found.png";
import androidImage from "../../assets/android_icon_image.svg";
import {
  deepCopy,
  getPaneIndex,
  getWindowLocationPath,
  kFormatter,
  getTextWithWrapHtml,
  getClass,
} from "../../redux/constants";
import isEqual from "react-fast-compare";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import PaginationComponent from "./PaginationComponent";
import PostCardFooter from "./PostCardFooter";
import PostCardFilters from "./PostCardFilters";
import SortBy from "./SortBy";
import moment from "moment";
import PostCardDetails from "./PostCardDetails";
import QuotedPost from "./QuotedPost";
import { Button, Checkbox, Empty, Input, Rate } from "antd";
import PostAttachment from "./PostAttachment";
import PostCardGrid from "./PostCardGrid";
import PostLabels from "./PostLabels";
import {
  postCardUserBrandCommentId,
  postCardUserbrandPrivateMessagesId,
  sentimentClass,
} from "../../redux/constants/enums";
import { getDynamicIconColor } from "../../redux/constants/DynamicIconColor";
import parse from "html-react-parser";
import { MentionIdComponent } from "./MentionIdComponent";

const PostCard = ({
  data,
  filterPills,
  totalPageNo,
  metadata,
  section_index,
  widget_index,
  mentionPage,
  pagination,
  deepDive,
  isPreviewState,
  dashboard,
  PdfDownloadStatus,
  PptGeneratingStatus,
  widget_id,
  noteExist,
  chart_type,
  isCommandCenterScreen,
  isTwitterTrendScreen,
  highlightWord,
}) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [visible, setVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const [isImage, setIsImage] = useState({});
  const [selectedChartType, setSelectedChartType] = useState("");
  const [search, setSerachString] = useState("");
  const [selectedOptions, setSelectedOption] = useState([]);
  const [postCardToGridResponse, setPostCardToGridResponse] = useState(
    metadata?.postCardToGridResponse ? metadata?.postCardToGridResponse : null
  );
  const Section = useSelector((state) => state.Section.addSection);
  const isshowSideBar = useSelector((state) => state.WidgetMaker.isshowSideBar);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const shareBrands = useSelector((state) => state?.ApiCall?.shareBrands);
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state?.ApiCall?.shareableLinkDeepDiveStatus
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const [refUpdated, setRefUpdated] = useState(false);
  // grid container ref
  const gridContainerRef = useRef(null);
  // callback function got called when reference of gridContainer is loaded
  const measuredGridContainerRef = useCallback((node) => {
    if (node !== null) {
      gridContainerRef.current = node;
      setRefUpdated(!refUpdated);
    }
  }, []);
  const [gridContainerStyle, setGridContainerStyle] = useState(
    gridContainerRef?.current
      ? {
          width: "100%",
          height:
            gridContainerRef?.current?.offsetHeight &&
            gridContainerRef?.current?.offsetHeight - 30,
        }
      : null
  );
  useEffect(() => {
    if (gridContainerRef?.current) {
      setGridContainerStyle({
        width: "100%",
        height:
          gridContainerRef?.current?.offsetHeight &&
          gridContainerRef?.current?.offsetHeight - 30,
      });
    }
  }, [gridContainerRef?.current]);

  let currentPath = window.location.pathname;
  let splitPath = currentPath.split("/");
  const handleWindowResize = () => {
    setWindowWidth(window.innerWidth);
  };

  let widget_metadata = Section?.[section_index]?.data?.[widget_index];

  useEffect(() => {
    let widgetMetaData;
    if (shareTemplateData) {
      if (section_index >= 0 && shareTemplateData?.sections) {
        widgetMetaData =
          shareTemplateData?.sections[section_index]?.widgets?.[widget_index];
      } else {
        widgetMetaData =
          shareTemplateData?.section?.[0]?.widgets?.[widget_index];
      }
    } else {
      let index = getPaneIndex(panes, activeKey);
      if (section_index >= 0 && panes?.[index]?.sections) {
        widgetMetaData =
          panes?.[index]?.sections[section_index]?.widgets?.[widget_index];
      } else {
        widgetMetaData = panes[index]?.section?.[0]?.widgets?.[widget_index];
      }
    }
    if (
      widgetMetaData?.selectedChartType &&
      widgetMetaData?.selectedChartType !== selectedChartType
    ) {
      setSelectedChartType(widgetMetaData?.selectedChartType);
    }
  }, [panes, shareTemplateData]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  // This useEffect is for calculating selectedChartType Of this post card widget
  const showModal = (data) => {
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(data);
  };
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  const onImageError = (e, id) => {
    if (e?.type === "error") {
      setIsImage({
        ...isImage,
        [id]: true,
      });
    } else {
      setIsImage({
        ...isImage,
        [id]: false,
      });
    }
    return (e.target.src = defaultImg);
  };
  const getGridDataBasedOnPostCardData = (
    selectedChartType,
    postCardData,
    postCardGraphCondition
  ) => {
    // console.log(
    //   "getGridDataBasedOnPostCardData got called :  ",
    //   postCardGraphCondition
    // );
    let columns = [];
    let dataSources = [];
    let selectionOptions = [];
    let selectedColumns = [];
    if (
      postCardData?.length > 0 &&
      selectedChartType &&
      selectedChartType === "grid"
    ) {
      if (postCardGraphCondition?.key_friendlyname_pairs) {
        Object?.entries(postCardGraphCondition?.key_friendlyname_pairs)?.map(
          (key_pair) => {
            columns?.push({ title: key_pair?.[1] });
            if (
              key_pair?.[0] &&
              postCardGraphCondition?.hide_columns?.length > 0 &&
              Array.isArray(postCardGraphCondition?.hide_columns) &&
              !postCardGraphCondition?.hide_columns?.includes(key_pair?.[0])
            ) {
              selectionOptions?.push({
                id: key_pair?.[1]?.trim()?.replace(/\s+/g, ""),
                name: key_pair?.[1],
              });
            }
            if (
              postCardData?.length > 0 &&
              Array.isArray(postCardData) &&
              key_pair?.[0]
            ) {
              postCardData?.map((pData, index) => {
                let sourceObj = dataSources?.[index]
                  ? { ...dataSources[index] }
                  : {};
                let value = pData?.[key_pair?.[0]];
                sourceObj[key_pair[1]] = value;
                if (dataSources[index]) {
                  dataSources[index] = sourceObj;
                } else {
                  dataSources?.push(sourceObj);
                }
              });
            }
          }
        );
      }
      if (
        selectionOptions &&
        Array.isArray(selectionOptions) &&
        selectionOptions?.length > 0 &&
        ((postCardGraphCondition?.default_selections &&
          Array.isArray(postCardGraphCondition?.default_selections) &&
          postCardGraphCondition?.default_selections?.length > 0) ||
          (metadata?.postCardToGridResponse?.selectedColumns &&
            Array.isArray(metadata?.postCardToGridResponse?.selectedColumns) &&
            metadata?.postCardToGridResponse?.selectedColumns?.length > 0))
      ) {
        if (
          metadata?.postCardToGridResponse?.selectedColumns &&
          Array.isArray(metadata?.postCardToGridResponse?.selectedColumns) &&
          metadata?.postCardToGridResponse?.selectedColumns?.length > 0
        ) {
          metadata?.postCardToGridResponse?.selectedColumns?.map((selected) => {
            let ind = selectionOptions?.findIndex((op) => {
              return op?.id === selected?.id;
            });
            if (ind !== -1) {
              selectedColumns?.push(selectionOptions?.[ind]);
            }
          });
          // need to be sort according to default sorted columns
          if (
            postCardGraphCondition?.default_selections &&
            Array.isArray(postCardGraphCondition?.default_selections) &&
            postCardGraphCondition?.default_selections?.length > 0
          ) {
            let sortedByDefultSorting = [];
            postCardGraphCondition?.default_selections?.map((selected) => {
              let ind = selectedColumns?.findIndex((op) => {
                return op?.id === selected?.trim()?.replace(/\s+/g, "");
              });
              if (ind !== -1) {
                sortedByDefultSorting?.push(selectedColumns?.[ind]);
              }
            });

            // Append remaining items from originalArray that are not in sortOrderArray
            selectedColumns?.forEach((item) => {
              if (
                !sortedByDefultSorting?.find(
                  (sortItem) => sortItem?.id === item?.id
                )
              ) {
                sortedByDefultSorting?.push(item);
              }
            });
            if (sortedByDefultSorting?.length > 0) {
              selectedColumns = [...sortedByDefultSorting];
            }
          }
        } else if (
          postCardGraphCondition?.default_selections &&
          Array.isArray(postCardGraphCondition?.default_selections) &&
          postCardGraphCondition?.default_selections?.length > 0
        ) {
          postCardGraphCondition?.default_selections?.map((selected) => {
            let ind = selectionOptions?.findIndex((op) => {
              return op?.id === selected?.trim()?.replace(/\s+/g, "");
            });
            if (ind !== -1) {
              selectedColumns?.push(selectionOptions?.[ind]);
            }
          });
        }
      }
    }
    let sortedSelectionOptions = [];
    let sortedFilterColumns = [];
    if (selectionOptions?.length > 0 && selectedColumns?.length > 0) {
      // Sort the original array based on the order of sortOrderArray
      selectedColumns?.filter((sortItem) => {
        let f = selectionOptions?.find((item) => item?.id === sortItem?.id);
        if (f) {
          sortedSelectionOptions?.push(f);
        }
      });
      // Append remaining items from originalArray that are not in sortOrderArray
      selectionOptions?.forEach((item) => {
        if (!selectedColumns?.find((sortItem) => sortItem?.id === item?.id)) {
          sortedSelectionOptions?.push(item);
        }
      });
      sortedSelectionOptions?.unshift({
        id: "Select All",
        name: "Select All",
      });
    }
    if (columns?.length > 0 && selectedColumns?.length > 0) {
      // Sort the original array based on the order of sortOrderArray
      selectedColumns?.forEach((sortItem) => {
        let f = columns?.find(
          (item) => sortItem?.id === item?.title?.trim()?.replace(/\s+/g, "")
        );
        if (f) {
          sortedFilterColumns?.push(f);
        }
      });

      // // Append remaining items from originalArray that are not in sortOrderArray
      // columns.forEach((item) => {
      //   if (!selectedColumns.find((sortItem) => sortItem.id === item.id)) {
      //     sortedFilterColumns.push(item);
      //   }
      // });
    }
    // console.log(
    //   "columns : ",
    //   columns,
    //   "selectedColumns : ",
    //   selectedColumns,
    //   "sortedSelectionOptions : ",
    //   sortedSelectionOptions,
    //   "sortedFilterColumns : ",
    //   sortedFilterColumns
    // );
    setSelectedOption(selectedColumns?.length > 0 ? selectedColumns : []);
    setPostCardToGridResponse({
      columns: sortedFilterColumns?.length > 0 ? sortedFilterColumns : columns,
      dataSources,
      hideColumns:
        postCardGraphCondition?.hide_columns?.length > 0
          ? postCardGraphCondition?.hide_columns
          : [],
      selectedColumns: selectedColumns?.length > 0 ? selectedColumns : [],
      selectionOptions:
        sortedSelectionOptions?.length > 0
          ? sortedSelectionOptions
          : selectionOptions?.length > 0
          ? selectionOptions
          : [],
    });
  };
  useEffect(() => {
    if (data?.length > 0 && selectedChartType && selectedChartType === "grid") {
      getGridDataBasedOnPostCardData(
        selectedChartType,
        data?.length > 0 ? deepCopy(data) : [],
        graphConditionConfig?.["post-card"]
      );
    }
  }, [metadata, data, selectedChartType]);

  const handleOnSelectChange = (data, el) => {
    // console.log(
    //   "handleOnSelectChange got called : ",
    //   data,
    //   el,
    //   selectedOptions
    // );
    let selectedValues = [];
    if (data?.target?.checked) {
      if (data?.target?.value === "Select All") {
        selectedValues = [...postCardToGridResponse?.selectionOptions, el];
      } else {
        selectedValues = [...selectedOptions, el];
      }
    } else {
      if (data?.target?.value === "Select All" && !data?.target?.checked) {
        selectedValues = [];
      } else {
        const index = selectedOptions?.findIndex(
          (obj) => obj?.name === "Select All"
        );
        if (index !== -1) {
          let selectedOption = selectedOptions?.filter((obj) => {
            if (obj?.name !== "Select All" && obj?.id !== el?.id) {
              return data;
            }
          });
          selectedValues = selectedOption;
        } else {
          const selectedValuesNew = selectedOptions?.filter((obj) => {
            if (el?.id !== obj?.id) {
              return obj;
            }
          });
          selectedValues = selectedValuesNew;
        }
      }
    }
    setSelectedOption(selectedValues);
  };

  const setIsCheckedOrNot = (data) => {
    if (selectedOptions?.length > 0) {
      const index = selectedOptions?.findIndex(
        (el) => el?.name === "Select All"
      );
      if (
        index !== -1 ||
        selectedOptions?.length ===
          postCardToGridResponse?.selectionOptions?.length - 1
      ) {
        return true;
      } else {
        const selectedOptionIndex = selectedOptions?.findIndex(
          (el) => el?.id === data?.id
        );
        if (selectedOptionIndex !== -1) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  };
  const getCurrentSelectedColumns = () => {
    let currentSelectedColumns = [];
    if (
      postCardToGridResponse?.selectionOptions &&
      Array.isArray(postCardToGridResponse?.selectionOptions) &&
      postCardToGridResponse?.selectionOptions?.length > 0 &&
      postCardToGridResponse?.selectedColumns &&
      Array.isArray(postCardToGridResponse?.selectedColumns) &&
      postCardToGridResponse?.selectedColumns?.length > 0
    ) {
      postCardToGridResponse?.selectedColumns?.map((selected) => {
        let ind = postCardToGridResponse?.selectionOptions?.findIndex((op) => {
          return op?.id === selected?.id;
        });
        if (ind !== -1) {
          currentSelectedColumns?.push(
            postCardToGridResponse?.selectionOptions?.[ind]
          );
        }
      });
    }
    let sortedSelectionOptions = [];
    let sortedFilterColumns = [];
    if (
      postCardToGridResponse?.selectionOptions?.length > 0 &&
      currentSelectedColumns?.length > 0
    ) {
      // Sort the original array based on the order of sortOrderArray
      sortedSelectionOptions = postCardToGridResponse?.selectionOptions?.filter(
        (sortItem) =>
          currentSelectedColumns?.find((item) => item?.id === sortItem?.id)
      );

      // Append remaining items from originalArray that are not in sortOrderArray
      postCardToGridResponse?.selectionOptions?.forEach((item) => {
        if (
          !currentSelectedColumns?.find((sortItem) => sortItem?.id === item?.id)
        ) {
          sortedSelectionOptions?.push(item);
        }
      });
    }
    return currentSelectedColumns;
  };
  const handleOnSubmitCloumns = (selectedColumns) => {
    // console.log(
    //   "handleOnSubmitCloumns postCardToGridResponse : ",
    //   postCardToGridResponse,
    //   selectedColumns
    // );
    let updatedColumns = selectedColumns
      ?.map((c) => {
        return c?.name !== "Select All" ? { title: c?.name } : null;
      })
      ?.filter((e) => e);
    let updatedPostCardToGridResponse = {
      ...postCardToGridResponse,
      columns: updatedColumns?.length > 0 ? updatedColumns : [],
      selectedColumns: selectedColumns?.length > 0 ? selectedColumns : [],
    };
    setPostCardToGridResponse(updatedPostCardToGridResponse);
    let index = getPaneIndex(panes, activeKey);
    if (shareTemplateData) {
      // share dashboard
      if (metadata) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].postCardToGridResponse = updatedPostCardToGridResponse;
        } else {
          updateShareTemplateData.section[0].widgets[
            widget_index
          ].postCardToGridResponse = updatedPostCardToGridResponse;
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }
    } else {
      // view dashboard
      if (metadata) {
        let updatePanes = [...panes];
        if (section_index >= 0) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].postCardToGridResponse = updatedPostCardToGridResponse;
        } else {
          updatePanes[index].section[0].widgets[
            widget_index
          ].postCardToGridResponse = updatedPostCardToGridResponse;
        }
        dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      }
    }
  };
  const handleVisibleChange = (newVisible, resetOption = true) => {
    if (resetOption) {
      const setdefaultValue = getCurrentSelectedColumns();
      setSelectedOption(setdefaultValue);
    }
    setVisible(newVisible);
    setSerachString("");
  };
  const handleCancel = () => {
    const setdefaultValue = getCurrentSelectedColumns();
    setSelectedOption(setdefaultValue);
    setVisible(false);
    setSerachString("");
  };

  const handleDone = () => {
    handleOnSubmitCloumns(selectedOptions);
    handleVisibleChange(false, false);
  };
  const handleColumnSearch = (e) => {
    setSerachString(e?.target?.value);
  };
  // console.log(
  //   "postCardToGridResponse : ",
  //   postCardToGridResponse,
  //   "selectedOptions : ",
  //   selectedOptions
  // );
  const isDeepDiveDashboardView = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    return (
      (authParams?.screen_id
        ? screen?.isDeepDiveDashboard
          ? true
          : false
        : shareableLinkDeepDiveStatus
        ? shareTemplateData?.isDeepDiveDashboard
          ? true
          : false
        : !authParams?.screen_id &&
          !shareBrands &&
          (pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
            ?.open_flag &&
          panes?.[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard
        ? true
        : false) && !deepdiveDashboardTemplateData?.isDeepDive
    );
  }, [
    screen,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
  ]);
  return (
    <>
      <PostCardFilters
        filterPills={filterPills}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        deepDive={deepDive}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        widget_id={widget_id}
        chart_type={chart_type}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
      {deepDive ||
      splitPath[1] === "widgetMaker" ||
      splitPath[1] === "edit-widget" ? (
        <div
          id={`post_card_${section_index ? section_index : "section_index"}_${
            widget_index ? widget_index : "widget_index"
          }`}
          className={`w-100 wm-chart-cards text-right`}
        >
          <SortBy
            filterPills={filterPills}
            metadata={metadata}
            section_index={section_index}
            widget_index={widget_index}
            isPreviewState={isPreviewState}
            PdfDownloadStatus={PdfDownloadStatus}
            PptGeneratingStatus={PptGeneratingStatus}
            widget_id={widget_id}
            chart_type={chart_type}
            dashboard={dashboard}
            deepDive={deepDive}
            isDeepDiveDashboardView={isDeepDiveDashboardView}
          />
        </div>
      ) : (
        <></>
      )}
      {selectedChartType === "grid" &&
      !["edit-dashboard", "create-dashboard"]?.includes(
        getWindowLocationPath()
      ) &&
      postCardToGridResponse?.columns?.length > 0 &&
      postCardToGridResponse?.dataSources?.length > 0 ? (
        <div className="d-flex">
          <div
            style={{
              maxHeight: "60rem",
              width: "calc(100% - 4rem)",
            }}
            ref={measuredGridContainerRef}
          >
            <PostCardGrid
              tableColumns={
                postCardToGridResponse?.columns?.length &&
                postCardToGridResponse?.columns
              }
              // tree_grid={
              //   single && single[0]?.columns?.length > 0 && single[0]?.tree_grid
              // }
              // rowSpanOn={
              //   single?.[0]?.columns?.length > 0 && single?.[0]?.row_span_on
              // }
              // grand_total={
              //   single &&
              //   single[0]?.columns?.length > 0 &&
              //   single[0]?.grand_total
              // }
              dataSource={
                postCardToGridResponse?.dataSources?.length > 0
                  ? postCardToGridResponse?.dataSources
                  : []
              }
              // colors={single && single[0]?.colors}
              PdfDownloadStatus={
                PdfDownloadStatus
                  ? PdfDownloadStatus
                  : PptGeneratingStatus
                  ? PptGeneratingStatus
                  : false
              }
              metadata={metadata}
              noteExist={noteExist}
              // insightsExist={insightsExist}
              // widgetDurationComparisonForChart={
              //   widgetDurationComparisonForChart
              // }
              // widgetDurationDataForChart={widgetDurationDataForChart}
              hideColumns={
                postCardToGridResponse?.hideColumns?.length &&
                postCardToGridResponse?.hideColumns
              }
              // hideSorting={hideSorting}
              // dateLabels={dateLabels}
              hidePagination={true}
              widgetContainerHeight={gridContainerStyle?.height}
              hideSortingOption={true}
              data={data}
              isPreviewState={isPreviewState}
              PptGeneratingStatus={PptGeneratingStatus}
              isCommandCenterScreen={isCommandCenterScreen}
              deepDive={deepDive}
              isDeepDiveDashboardView={isDeepDiveDashboardView}
            />
          </div>
          <div className="pt-15">
            <Popover
              content={
                postCardToGridResponse?.selectionOptions?.length > 0 &&
                Array.isArray(postCardToGridResponse?.selectionOptions) ? (
                  <div className="p-15">
                    <div>
                      <Input
                        className="border-radius-4 border-color mb-3"
                        placeholder="Search Columns"
                        style={{ height: "3.5rem" }}
                        value={search}
                        allowClear={true}
                        onChange={(e) => handleColumnSearch(e)}
                      />
                    </div>
                    <div
                      className="custom_scroll"
                      style={{ maxHeight: "25rem", overflow: "auto" }}
                    >
                      {postCardToGridResponse?.selectionOptions?.map(
                        (option) => {
                          return (
                            <>
                              {!search ||
                              search?.length === 0 ||
                              (search &&
                                search?.length > 0 &&
                                option?.name?.toLowerCase() !==
                                  "Select All"?.toLowerCase() &&
                                option?.name
                                  ?.toLowerCase()
                                  ?.includes(search?.toLowerCase())) ? (
                                <div
                                  className="d-flex align-items-center mb-1"
                                  key={option?.id}
                                >
                                  <Checkbox
                                    onChange={(item) =>
                                      handleOnSelectChange(item, option)
                                    }
                                    value={option?.name}
                                    checked={setIsCheckedOrNot(option)}
                                    style={{
                                      display: "inline-flex",
                                      lineHeight: "normal",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Tooltip
                                      title={option?.name}
                                      placement="right"
                                    >
                                      {" "}
                                      <span className="text_heading text-wrap font-weight400">
                                        {option?.name}
                                      </span>
                                    </Tooltip>
                                  </Checkbox>
                                </div>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        }
                      )}
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <Button
                        onClick={() => handleCancel()}
                        className="btn_Clear mr-15"
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={() => handleDone()}
                        type="primary"
                        className={`ant-btn-primary_blue`}
                        disabled={selectedOptions?.length > 0 ? false : true}
                      >
                        Done
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div
                    className="p-15 d-flex justify-content-center flex-direction-column align-items-center"
                    style={{ width: "40rem" }}
                  >
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      style={{ margin: "auto" }}
                    />
                  </div>
                )
              }
              trigger="click"
              open={visible}
              onOpenChange={(e) => {
                handleVisibleChange(e);
              }}
              placement="bottomRight"
              overlayClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              <button
                className={`WidgetFilter_title ${shareTemplateData && "mr-2"}`}
                style={{
                  borderColor: "#678bff33",
                  lineHeight: "1.8rem",
                }}
              >
                <img
                  src={
                    authParams?.theme_type === "1"
                      ? CustomizedIcon
                      : CustomizedIcon
                  }
                  alt="Post card sorts"
                  className="mr-0"
                  style={{ width: "2.5rem" }}
                />
              </button>
            </Popover>
          </div>
        </div>
      ) : data?.length > 0 ? (
        <>
          <div
            className={`row ${
              isTwitterTrendScreen ? "w-100" : "mr-15"
            } ml-0 mb-1  ${
              PdfDownloadStatus ||
              PptGeneratingStatus ||
              (splitPath[1] !== "widgetMaker" &&
                splitPath[1] !== "edit-widget" &&
                !deepDive &&
                !isTwitterTrendScreen)
                ? "mt-15"
                : ""
            }`}
          >
            {data?.map((el, i) => {
              let qrChannel =
                el &&
                el?.SurveySubmitJson &&
                Array?.isArray(el?.SurveySubmitJson) &&
                el?.SurveySubmitJson?.length > 0;
              let pantipChannel = el?.PlatformID === 43;
              if (
                (PdfDownloadStatus || PptGeneratingStatus || qrChannel) &&
                noteExist &&
                i > 2
              )
                return null;
              // if (PptGeneratingStatus) {
              //   if (windowWidth <= 1300) {
              //     if (windowWidth <= 850 && i > 2) return null;
              //     else if (i > 3) return null;
              //   } else if (windowWidth > 1300 && windowWidth <= 2450) {
              //     if (windowWidth <= 1846 && i > 5) return null;
              //     else if (i > 7) return null;
              //   } else if (windowWidth > 2450 && i > 11) {
              //     return null;
              //   }
              // }
              if ((PdfDownloadStatus || PptGeneratingStatus) && i > 5)
                return null;

              return (
                <div
                  key={`${el?.TagID}_${i}`}
                  // style={{
                  //   backgroundColor: isCommandCenterScreen
                  //     ? "var(--cc-screenContainer-color)"
                  //     : "",
                  // }}
                  className={`${
                    isTwitterTrendScreen
                      ? "col-12 col-xl-12 col-lg-12 col-md-12"
                      : PdfDownloadStatus
                      ? "col-4 col-md-4"
                      : "col-12 col-md-6"
                  } ${
                    isTwitterTrendScreen
                      ? ""
                      : !dashboard
                      ? "col-lg-6"
                      : "col-lg-4"
                  } ${
                    PdfDownloadStatus ||
                    PptGeneratingStatus ||
                    isTwitterTrendScreen
                      ? ""
                      : isPreviewState
                      ? windowWidth < 1400
                        ? "col-md-12 col-lg-12"
                        : windowWidth > 2450
                        ? "col-xl-4"
                        : "col-lg-6"
                      : (!isshowSideBar || isshowSideBar) &&
                        !dashboard &&
                        !mentionPage
                      ? windowWidth < 1400
                        ? "col-md-12 col-lg-12"
                        : windowWidth > 1846 && windowWidth <= 2200
                        ? "col-xl-4"
                        : windowWidth > 2200
                        ? "col-xl-3"
                        : "col-lg-6"
                      : metadata?.span === "one_third" ||
                        widget_metadata?.span === "one_third"
                      ? windowWidth > 2450
                        ? "col-md-6 col-lg-6"
                        : "col-md-12 col-lg-12"
                      : metadata?.span === "two_third" ||
                        widget_metadata?.span === "two_third"
                      ? windowWidth < 1300
                        ? "col-md-12 col-lg-12"
                        : windowWidth > 1526 && windowWidth <= 2450
                        ? windowWidth <= 1850
                          ? "col-xl-6"
                          : "col-xl-4"
                        : windowWidth > 2450
                        ? "col-xl-3"
                        : "col-md-6 col-lg-6"
                      : metadata?.span === "half" ||
                        widget_metadata?.span === "half"
                      ? windowWidth < 1700
                        ? "col-md-12 col-lg-12"
                        : "col-md-6 col-lg-6"
                      : windowWidth < 1300
                      ? windowWidth < 850
                        ? "col-sd-12 col-md-12 col-lg-6"
                        : "col-sd-12 col-lg-6"
                      : windowWidth > 1526 && windowWidth <= 2450
                      ? windowWidth <= 1846
                        ? "col-xl-4"
                        : "col-xl-3"
                      : windowWidth > 2450 && "col-xl-2"
                  } pr-0 ${
                    isTwitterTrendScreen
                      ? "pl-0 highlighted-border-bottom twitterWidth"
                      : ""
                  }`}
                >
                  <div
                    className={`card-dash card cardList postCardItem border-0 mb-2 text-left ${
                      qrChannel ? "survey-card" : ""
                    } ${
                      authParams?.screen_id !== "000-000-567"
                        ? "postcard-class-for-mention"
                        : ""
                    }
                     ${
                       authParams?.screen_id !== "000-000-567"
                         ? sentimentClass[el.SentimentType] ||
                           "default-text-color"
                         : ""
                     }`}
                  >
                    <MentionIdComponent
                      color={el?.SentimentType}
                      id={el?.mention_id}
                      postCard={true}
                    />
                    <div
                      className={`cardList-head card-head text_heading d-flex justify-content-between p-15 pt-10 pb-0 mt-0 align-items-top pt-0 mb-2px ${
                        el?.SentimentType && !qrChannel ? "pl-0 pdf__pl--0" : ""
                      } ${
                        el?.IsDeletedFromSocial && !qrChannel
                          ? "pr-0 pdf__pr--0"
                          : ""
                      } ${
                        postCardUserbrandPrivateMessagesId?.includes(
                          el?.channel_type
                        )
                          ? getClass(authParams, "message")
                          : el?.PlatformID == 1 &&
                            el?.ParentSocialID !== "NA" &&
                            el?.ParentSocialID != 0 &&
                            el?.ParentSocialID !== ""
                          ? getClass(authParams, "comment")
                          : postCardUserBrandCommentId?.includes(
                              el?.channel_type
                            ) && el?.PlatformID != 1
                          ? getClass(authParams, "comment")
                          : getClass(authParams, "post")
                      }`}
                    >
                      <div
                        className="d-flex align-items-center "
                        style={{ width: "60%" }}
                      >
                        {el?.SentimentType && !isTwitterTrendScreen ? (
                          <div
                            style={{
                              borderLeft: `0.4rem solid ${
                                el?.SentimentType === "Positive"
                                  ? "#5ED142"
                                  : el?.SentimentType === "Negative"
                                  ? "#FF5D48"
                                  : el?.SentimentType === "Neutral"
                                  ? "#F0C52F"
                                  : "black"
                              }`,
                              height: "3.6rem",
                              marginRight: "1rem",
                            }}
                            className={`${qrChannel ? "d-none" : ""}`}
                          ></div>
                        ) : (
                          ""
                        )}

                        {!isTwitterTrendScreen ? (
                          <>
                            {el?.brand_logo &&
                            el?.brand_logo !== "NA" &&
                            el?.BrandFriendlyName &&
                            el?.BrandFriendlyName !== "NA" &&
                            el?.BrandFriendlyName !== "" ? (
                              <Popover
                                placement="leftBottom"
                                title={null}
                                content={
                                  <div
                                    style={{
                                      maxWidth: "25rem",
                                      maxHeight: "20rem",
                                      overflow: "auto",
                                    }}
                                    className="text_regular fontSize-12 p-10"
                                  >
                                    {el?.BrandFriendlyName}
                                  </div>
                                }
                                overlayClassName={
                                  authParams?.theme_type === "1"
                                    ? "darkTheme"
                                    : "lightTheme"
                                }
                              >
                                <Image
                                  src={
                                    el?.brand_logo
                                      ? el?.brand_logo
                                      : Default_Brand
                                  }
                                  fallback={
                                    el?.brand_logo
                                      ? el?.brand_logo
                                      : Default_Brand
                                  }
                                  preview={false}
                                  alt="Brand logo"
                                  className={`profileImg mr-1 cursor-pointer ${
                                    qrChannel ? "d-none" : ""
                                  }`}
                                  style={{
                                    width: "3.5rem",
                                    height: "3.5rem",
                                  }}
                                  onError={getDefautBrandImg}
                                  // crossOrigin="anonymous"
                                />
                              </Popover>
                            ) : el?.BrandFriendlyName &&
                              el?.BrandFriendlyName !== "NA" &&
                              el?.BrandFriendlyName !== "" ? (
                              <Popover
                                placement="leftBottom"
                                title={null}
                                content={
                                  <div
                                    style={{
                                      maxWidth: "25rem",
                                      maxHeight: "20rem",
                                      overflow: "auto",
                                    }}
                                    className="text_regular fontSize-12 p-10"
                                  >
                                    {el?.BrandFriendlyName}
                                  </div>
                                }
                                overlayClassName={
                                  authParams?.theme_type === "1"
                                    ? "darkTheme"
                                    : "lightTheme"
                                }
                              >
                                <Image
                                  src={
                                    el?.brand_logo && el?.brand_logo !== "NA"
                                      ? el?.brand_logo
                                      : Default_Brand
                                  }
                                  fallback={
                                    el?.brand_logo && el?.brand_logo !== "NA"
                                      ? el?.brand_logo
                                      : Default_Brand
                                  }
                                  preview={false}
                                  alt="Brand logo"
                                  onError={getDefautBrandImg}
                                  className="profileImg mr-1 cursor-pointer"
                                  style={{
                                    width: "3.5rem",
                                    height: "3.5rem",
                                    //marginTop: "-0.5rem",
                                  }}
                                  // crossOrigin="anonymous"
                                />
                              </Popover>
                            ) : (
                              <Image
                                src={
                                  el?.brand_logo && el?.brand_logo !== "NA"
                                    ? el?.brand_logo
                                    : Default_Brand
                                }
                                fallback={
                                  el?.brand_logo && el?.brand_logo !== "NA"
                                    ? el?.brand_logo
                                    : Default_Brand
                                }
                                preview={false}
                                alt="Brand logo"
                                onError={getDefautBrandImg}
                                className={`profileImg ${
                                  qrChannel ? "d-none" : ""
                                } mr-1 cursor-pointer`}
                                style={{
                                  width: "3.5rem",
                                  height: "3.5rem",
                                  //marginTop: "-0.5rem",
                                }}
                                // crossOrigin="anonymous"
                              />
                            )}
                          </>
                        ) : (
                          ""
                        )}

                        <div
                          className="position-relative mr-15"
                          style={{ width: "3.5rem" }}
                        >
                          {!PdfDownloadStatus && !PptGeneratingStatus ? (
                            el?.AuthorBio &&
                            el?.AuthorBio !== "NA" &&
                            el?.AuthorBio !== "" ? (
                              <Popover
                                placement="leftBottom"
                                title={null}
                                content={
                                  <div className="p-15">
                                    {el?.AuthorBio &&
                                    el?.AuthorBio !== "NA" &&
                                    el?.AuthorBio !== "" ? (
                                      <div className="text_regular font-weight500">
                                        Bio
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    <div
                                      style={{
                                        maxWidth: "25rem",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                      className="text_regular fontSize-12 custom_scroll1"
                                    >
                                      {el?.AuthorBio &&
                                      el?.AuthorBio !== "NA" &&
                                      el?.AuthorBio !== "" ? (
                                        <>{el?.AuthorBio}</>
                                      ) : (
                                        <div className="text-grayLight fontSize-14 d-flex justify-content-center align-items-center w-100">
                                          Bio not found
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                }
                                overlayClassName={
                                  authParams?.theme_type === "1"
                                    ? "darkTheme"
                                    : "lightTheme"
                                }
                              >
                                <Image
                                  src={
                                    el?.ProfilePicture === 0 ||
                                    el?.ProfilePicture === "" ||
                                    !el?.ProfilePicture
                                      ? Profile
                                      : el?.ProfilePicture
                                  }
                                  fallback={Profile}
                                  preview={false}
                                  alt="Profile Images"
                                  className={`profileImg ${
                                    qrChannel ? "ml-1" : "m-0"
                                  } cursor-pointer`}
                                  style={{ width: "3.5rem", height: "3.5rem" }}
                                  {...(PdfDownloadStatus || PptGeneratingStatus
                                    ? { crossOrigin: "anonymous" }
                                    : {})}
                                  // crossOrigin="anonymous"
                                />
                              </Popover>
                            ) : (
                              <Image
                                src={
                                  el?.ProfilePicture === 0 ||
                                  el?.ProfilePicture === "" ||
                                  !el?.ProfilePicture
                                    ? Profile
                                    : el?.ProfilePicture
                                }
                                fallback={Profile}
                                preview={false}
                                alt="Profile Images"
                                className={`profileImg ${
                                  qrChannel ? "ml-1" : "m-0"
                                } cursor-pointer`}
                                style={{ width: "3.5rem", height: "3.5rem" }}
                                {...(PdfDownloadStatus || PptGeneratingStatus
                                  ? { crossOrigin: "anonymous" }
                                  : {})}
                                // crossOrigin="anonymous"
                              />
                            )
                          ) : (
                            <Image
                              src={
                                PdfDownloadStatus || PptGeneratingStatus
                                  ? el?.ProfilePicture === 0 ||
                                    el?.ProfilePicture === "" ||
                                    !el?.ProfilePicture
                                    ? Profile
                                    : el?.ProfilePicture
                                  : Profile
                              }
                              fallback={Profile}
                              preview={false}
                              alt="Profile Images"
                              className="profileImg m-0 cursor-pointer"
                              style={{ width: "3.5rem", height: "3.5rem" }}
                              {...(PdfDownloadStatus || PptGeneratingStatus
                                ? { crossOrigin: "anonymous" }
                                : {})}
                              // crossOrigin="anonymous"
                            />
                          )}
                          <div
                            className="position-absolute"
                            style={{
                              right: "-0.8rem",
                              top: "-0.4rem",
                            }}
                          >
                            <Image
                              src={
                                el?.PlatformID === 0
                                  ? Default_Brand
                                  : SocialMedialogo?.[el?.PlatformID]
                                  ? SocialMedialogo?.[el?.PlatformID]
                                  : Default_Brand
                              }
                              alt="Channel"
                              preview={false}
                              fallback={Default_Brand}
                              style={{
                                width: "1.6rem",
                                maxHeight: "2rem",
                                verticalAlign: "top",
                              }}
                            />
                          </div>
                        </div>
                        {/* Changing max width logic here if sentimentType exits subtracting 1.5rem ,
                            85px + 0.4rem for Brand and Profile so Author Name box should not go outside  */}
                        <div
                          // style={{ width: "calc(100% - 6rem)" }}
                          style={{
                            width: `calc(100% - ${
                              (el?.SentimentType && !isTwitterTrendScreen
                                ? 15
                                : 0) +
                              (!isTwitterTrendScreen ? 35 : 0) + // for brand
                              50 // for profile
                            }px - ${!isTwitterTrendScreen ? 0.4 : 0}rem)`,
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <Tooltip title={el?.AuthorName}>
                              <div
                                className="profileName text-ellipsis line-height-normal"
                                style={{
                                  maxWidth:
                                    (el?.AuthorIsVerified !== "NA" &&
                                      el?.AuthorIsVerified &&
                                      el?.AuthorIsVerified > 0) ||
                                    [1, 2]?.includes(el?.isPromoted)
                                      ? "calc(100% - 2.5rem)"
                                      : "",
                                }}
                              >
                                {el?.AuthorURL && el?.AuthorURL !== "NA" ? (
                                  <a
                                    className={
                                      el?.AuthorURL && el?.AuthorURL !== "NA"
                                        ? ""
                                        : "pointer-events1 cursor-default"
                                    }
                                    href={
                                      el?.AuthorURL && el?.AuthorURL !== "NA"
                                        ? el?.AuthorURL
                                        : ""
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {el?.AuthorName}
                                  </a>
                                ) : (
                                  <>{el?.AuthorName}</>
                                )}
                              </div>
                            </Tooltip>
                            {el?.AuthorIsVerified !== "NA" &&
                            el?.AuthorIsVerified &&
                            el?.AuthorIsVerified > 0 ? (
                              <img
                                src={verified}
                                alt="verified"
                                className="profileImg ml-1"
                                style={{ height: "1.6rem" }}
                              />
                            ) : (
                              ""
                            )}

                            {el?.isPromoted === 1 ? (
                              <Tooltip title="Boosted post">
                                <img
                                  alt="Boosted Post Icon"
                                  src={BoostedPostIcon}
                                  className="mr-0"
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                  }}
                                />
                              </Tooltip>
                            ) : el?.isPromoted === 2 || el?.isPromoted === 5 ? (
                              <Tooltip
                                title={
                                  el?.isPromoted === 5
                                    ? "Dark Ad Post"
                                    : "Ad Post"
                                }
                              >
                                <img
                                  alt="Ad Post Icon"
                                  src={AdsPostIcon}
                                  className="mr-0"
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                  }}
                                />
                              </Tooltip>
                            ) : (
                              ""
                            )}
                          </div>
                          {el?.AuthorScreenName &&
                          el?.PlatformID !== 2 &&
                          el?.PlatformID !== 5 ? (
                            <div
                              className="screenName text-grayLight text-ellipsis w-100 themed-widget-text-color"
                              //style={{ width: "90%" }}
                            >
                              <Tooltip title={el?.AuthorScreenName}>
                                {el?.AuthorURL && el?.AuthorURL !== "NA" ? (
                                  <a
                                    className={
                                      el?.AuthorURL && el?.AuthorURL !== "NA"
                                        ? ""
                                        : "pointer-events1 cursor-default"
                                    }
                                    href={
                                      el?.AuthorURL && el?.AuthorURL !== "NA"
                                        ? el?.AuthorURL
                                        : ""
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {el?.AuthorScreenName}
                                  </a>
                                ) : (
                                  <>{el?.AuthorScreenName}</>
                                )}
                              </Tooltip>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <span
                        className="font-size12 align-items-center d-flex date-icons-header"
                        style={{ maxWidth: "40%" }}
                      >
                        <Tooltip
                          title={
                            <div>
                              Created Date : <br />{" "}
                              {el?.CreatedDate
                                ? el?.CreatedDate
                                : el?.PostCreatedDate}
                            </div>
                          }
                          className="no--wrap"
                        >
                          {/* <img
                            src={ClockIcon}
                        className="cardList__footer-label"
                            alt="ClockIcon"
                          /> */}
                          <span className="cardList__footer-label">
                            {" "}
                            {getDynamicIconColor("clock_icon")}
                          </span>

                          <span className="cardList__footer-count text-grayLight">
                            {el?.CreatedDate
                              ? moment(el?.CreatedDate)?.format("DD MMM YYYY")
                              : moment(el?.PostCreatedDate)?.format(
                                  "DD MMM YYYY"
                                )}
                          </span>
                        </Tooltip>
                        {el?.IsDeletedFromSocial && !isTwitterTrendScreen ? (
                          <Tooltip
                            title={<div>Deleted From Social</div>}
                            placement="topRight"
                            className="no--wrap"
                          >
                            <span
                              className={` deletedFromSocialIcon ${
                                qrChannel
                                  ? "d-none"
                                  : "d-flex align-items-center"
                              } `}
                            >
                              <i className="fas fa-trash-alt trash__icon"></i>
                            </span>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </span>
                    </div>
                    <div className="card-body p-0">
                      {!PdfDownloadStatus && el?.PlatformID === 1 && (
                        <div
                          className={`${
                            PdfDownloadStatus ? "mb-5" : "mb-15"
                          }  pl-15 ${
                            qrChannel ? "d-none" : "d-flex"
                          } pr-15 no--wrap`}
                        >
                          {/* Followers Icon here   */}
                          <div>{getDynamicIconColor("FollowersIcon")}</div>
                          <span
                            className="text-grayLight ml-1"
                            // style={{
                            //   color: "var(--locobuzz-chart-text--color)",
                            // }}
                          >
                            Followers
                          </span>
                          <Tooltip title={el?.Followers?.toLocaleString()}>
                            <span
                              className={`cardList__footer-count ml-1  font-weight800 ${
                                window.location.pathname
                                  .toLowerCase()
                                  .includes("/commandcenter/screens")
                                  ? "dynamic_icon_color"
                                  : "blue-text"
                              }`}
                            >
                              {kFormatter(el?.Followers)}
                            </span>
                          </Tooltip>
                        </div>
                      )}
                      {/* Additional for E-Commerce channel */}
                      {el?.PlatformID === 14 ? (
                        <span className="ml-15 mb-10 d-flex align-items-center">
                          <span className="w-100">
                            <span
                              className={
                                authParams?.screen_id &&
                                !isDeepDiveDashboardView
                                  ? "color-white"
                                  : ""
                              }
                            >
                              Title :
                            </span>
                            <span
                              className={
                                authParams?.screen_id &&
                                !isDeepDiveDashboardView
                                  ? "color-white font-weight800"
                                  : "font-weight800"
                              }
                            >
                              {" "}
                              {getTextWithWrapHtml(
                                el?.Title !== "" &&
                                  el?.Title !== "NA" &&
                                  el?.Title
                                  ? el?.Title
                                  : "NA",
                                "",
                                highlightWord
                              )}
                            </span>
                          </span>
                        </span>
                      ) : (
                        ""
                      )}
                      {el?.PlatformID === 14 ? (
                        <span className="ml-15 mb-10 d-flex align-items-center">
                          <span className="w-100 " style={{}}>
                            <span
                              className={
                                authParams?.screen_id &&
                                !isDeepDiveDashboardView
                                  ? "color-white"
                                  : ""
                              }
                            >
                              Product Name :
                            </span>
                            <span
                              className={
                                authParams?.screen_id &&
                                !isDeepDiveDashboardView
                                  ? "color-white font-weight800"
                                  : "font-weight800"
                              }
                            >
                              {" "}
                              {getTextWithWrapHtml(
                                el?.ProductName !== "" &&
                                  el?.ProductName !== "NA" &&
                                  el?.ProductName
                                  ? el?.ProductName
                                  : "NA",
                                "",
                                highlightWord
                              )}
                            </span>
                          </span>
                        </span>
                      ) : (
                        ""
                      )}
                      {(el?.PlatformID === 7 || el?.PlatformID === 30) &&
                      el?.IsBrandPost === "User" ? (
                        <>
                          <div className="mb-2 pl-15 d-flex justify-content-between pr-15">
                            {el?.Rating >= 0 ? (
                              <span className="mr-15 d-flex align-items-center">
                                <Rate
                                  disabled
                                  value={el?.Rating ? el?.Rating : el?.rating}
                                  className="no--wrap w-100 ratingList mr-1 "
                                />
                                {el?.Rating}
                              </span>
                            ) : (
                              ""
                            )}
                            {el?.PlatformID === 7 ? (
                              <span className="mr-15 d-flex align-items-center">
                                <span
                                  className="w-100 text-ellipsis mr-1"
                                  style={{ color: "blue" }}
                                >
                                  App Version:
                                </span>
                                {el?.App_version === "NA" ? (
                                  <>
                                    <i
                                      className={`fa fa-minus cursor-pointer ml-1 fontSize-12 ${
                                        window.location.pathname
                                          .toLowerCase()
                                          ?.includes("/commandcenter/screens")
                                          ? "dynamic_icon_color"
                                          : "text-gray"
                                      }`}
                                    />
                                    <Tooltip
                                      title="Version information is not available for this review."
                                      placement="top"
                                      className="text-ellipsis d-inline-block wm-chart-card-title"
                                    >
                                      <i
                                        className={`fa fa-info-circle cursor-pointer ml-1 ${
                                          window.location.pathname
                                            .toLowerCase()
                                            ?.includes("/commandcenter/screens")
                                            ? "dynamic_icon_color"
                                            : "text-gray"
                                        }`}
                                        style={{ overflow: "visible" }}
                                      />
                                    </Tooltip>
                                  </>
                                ) : (
                                  el?.App_version
                                )}
                              </span>
                            ) : (
                              ""
                            )}
                            {el?.PlatformID === 7 ? (
                              <span className="mr-15 d-flex align-items-center">
                                <img
                                  src={androidImage}
                                  alt="Android Image"
                                  className="profileImg ml-1 mr-1"
                                  style={{ width: "1.5rem" }}
                                />
                                {el?.Android_version}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          {el?.PlatformID === 7 ? (
                            <span className="ml-15 mb-5 d-flex align-items-center">
                              <span className="d-flex w-100">
                                <span
                                  style={{ color: "blue" }}
                                  className="text-ellipsis mr-1"
                                >
                                  Device Name:
                                </span>
                                <span className="text-ellipsis">
                                  {el?.Device}
                                </span>
                              </span>
                            </span>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}

                      <PostAttachment
                        el={el}
                        i={i}
                        PdfDownloadStatus={PdfDownloadStatus}
                        PptGeneratingStatus={PptGeneratingStatus}
                        data={data}
                        isPreviewState={isPreviewState}
                        postText={el?.PostText}
                        deepDive={deepDive}
                        custom_card_settings={metadata}
                        isCommandCenterScreen={isCommandCenterScreen}
                        qrChannel={qrChannel}
                        pantipChannel={pantipChannel}
                        section_index={section_index}
                        widget_index={widget_index}
                        isTwitterTrendScreen={isTwitterTrendScreen}
                        highlightWord={highlightWord}
                        isDeepDiveDashboardView={isDeepDiveDashboardView}
                      />

                      {el?.EmailContentHtml !== "NA" &&
                        el?.EmailContentHtml &&
                        !qrChannel && (
                          <QuotedPost
                            el={el?.EmailContentHtml}
                            i={i}
                            PdfDownloadStatus={PdfDownloadStatus}
                            PptGeneratingStatus={PptGeneratingStatus}
                            isDeepDiveDashboardView={isDeepDiveDashboardView}
                          />
                        )}
                    </div>

                    <div>
                      {el?.post_label &&
                      Array.isArray(el?.post_label) &&
                      el?.post_label?.length > 0 ? (
                        <div className="ner-attribute p-15 pb-0 m-0">
                          <div className="text_regular font-weight500">
                            {el?.post_label?.length > 1 ? "Labels:" : "Label:"}
                          </div>
                          <PostLabels pills={el?.post_label} />
                        </div>
                      ) : (
                        ""
                      )}

                      <PostCardFooter
                        data={data}
                        isPreviewState={isPreviewState}
                        PdfDownloadStatus={PdfDownloadStatus}
                        PptGeneratingStatus={PptGeneratingStatus}
                        el={el}
                        deepDive={deepDive}
                        qrChannel={qrChannel}
                        pantipChannel={pantipChannel}
                        isTwitterTrendScreen={isTwitterTrendScreen}
                        highlightWord={highlightWord}
                        section_index={section_index}
                        widget_index={widget_index}
                        isDeepDiveDashboardView={isDeepDiveDashboardView}
                      />
                      {el?.PlatformID === 7 ||
                      el?.PlatformID === 30 ||
                      qrChannel ||
                      pantipChannel ||
                      isTwitterTrendScreen ? (
                        ""
                      ) : (
                        <div className="card-footer text-center bg__white text_regular d-flex align-items-top pt-2 pb-2 pl-15 pr-15 border-top border-color">
                          <div className="mr-15" style={{ width: "25%" }}>
                            <div
                              className={`text_regular text-grayLight white-space-nowrap`}
                              // className={`text_regular text-grayLight white-space-nowrap
                              //   ${deepDive ? "text_regular_DD" : ""}
                              // `}
                            >
                              Engagement
                            </div>
                            <div
                              className={`${
                                PdfDownloadStatus ? "" : "font-size18"
                              } text_heading-Rubik line-height-normal`}
                            >
                              {PdfDownloadStatus ? (
                                <>
                                  <div>
                                    {kFormatter(el?.Engagement)}{" "}
                                    {el?.PlatformID === 3 &&
                                    el?.isPromoted === 5 ? (
                                      <Tooltip
                                        title={
                                          "This Post Has No AD ID, So Engagement Only Includes Basic Stats Like Likes And Comments."
                                        }
                                      >
                                        <img
                                          src={InfoIconYellow}
                                          style={{ maxWidth: "1.5rem" }}
                                          className="mr-1 cursor-pointer"
                                          alt="info"
                                        />
                                      </Tooltip>
                                    ) : el?.engagement_fx ? (
                                      <Tooltip title={el?.Engagement_text}>
                                        <img
                                          src={fx}
                                          style={{ maxWidth: "1.5rem" }}
                                          className="mr-1 cursor-pointer"
                                          alt="fx"
                                        />
                                      </Tooltip>
                                    ) : (
                                      ""
                                    )}{" "}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>{kFormatter(el?.Engagement)}</div>
                                  {el?.PlatformID === 3 &&
                                  el?.isPromoted === 5 ? (
                                    <Tooltip
                                      title={
                                        "This Post Has No AD ID, So Engagement Only Includes Basic Stats Like Likes And Comments."
                                      }
                                    >
                                      <img
                                        src={InfoIconYellow}
                                        style={{ maxWidth: "1.5rem" }}
                                        className="mr-1 cursor-pointer"
                                        alt="info"
                                      />
                                    </Tooltip>
                                  ) : el?.engagement_fx ? (
                                    <Tooltip title={el?.Engagement_text}>
                                      <img
                                        src={fx}
                                        style={{ maxWidth: "1.5rem" }}
                                        className="mr-1 cursor-pointer"
                                        alt="fx"
                                      />
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </div>
                            {/* <Progress
                    percent={el?.Engagement}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                    /> */}
                          </div>
                          <div className="mr-15" style={{ width: "25%" }}>
                            <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                              <Tooltip title="Engagement Rate">
                                <div className="white-space-nowrap">
                                  Eng. Rate
                                </div>
                              </Tooltip>
                            </div>
                            <div
                              className={`${
                                PdfDownloadStatus ? "" : "font-size18"
                              } text_heading-Rubik line-height-normal`}
                            >
                              {PdfDownloadStatus ? (
                                <>
                                  <div>
                                    {kFormatter(el?.Engagement_rate)}{" "}
                                    {el?.Engagement_rate_fx ? (
                                      <Tooltip title={el?.Engagement_rate_text}>
                                        <img
                                          src={fx}
                                          style={{ maxWidth: "1.5rem" }}
                                          className="mr-1 cursor-pointer"
                                          alt="fx"
                                        />
                                      </Tooltip>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>{kFormatter(el?.Engagement_rate)}</div>
                                  {el?.Engagement_rate_fx ? (
                                    <Tooltip title={el?.Engagement_rate_text}>
                                      <img
                                        src={fx}
                                        style={{ maxWidth: "1.5rem" }}
                                        className="mr-1 cursor-pointer"
                                        alt="fx"
                                      />
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </div>
                            {/* <Progress
                    percent={el?.Engagement}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                    /> */}
                          </div>
                          <div className="mr-15" style={{ width: "25%" }}>
                            <div
                              className={`text_regular text-grayLight d-inline-flex align-items-center ${
                                el?.reach_fx ? "cursor-pointer" : ""
                              }`}
                            >
                              {el?.reach_fx ? (
                                <Tooltip title="Estimated Reach">
                                  <div className="white-space-nowrap">
                                    Est. Reach
                                  </div>
                                </Tooltip>
                              ) : (
                                <div className="white-space-nowrap">Reach</div>
                              )}
                              {el?.reach_i && (
                                <Tooltip title="It looks like this video post has been watched by the same viewers multiple times.">
                                  <img
                                    src={InfoIcon}
                                    alt="InfoIcon"
                                    className="ml-1"
                                  />
                                </Tooltip>
                              )}
                            </div>
                            <div
                              className={`${
                                PdfDownloadStatus ? "" : "font-size18"
                              } text_heading-Rubik line-height-normal`}
                            >
                              {PdfDownloadStatus ? (
                                <>
                                  <div>
                                    {kFormatter(el?.Reach)}{" "}
                                    {el?.reach_fx && (
                                      <Tooltip title={el?.Reach_text}>
                                        <img
                                          src={fx}
                                          style={{ maxWidth: "1.5rem" }}
                                          className="mr-1 cursor-pointer"
                                          alt="fx"
                                        />
                                      </Tooltip>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div> {kFormatter(el?.Reach)}</div>
                                  {el?.reach_fx && (
                                    <Tooltip title={el?.Reach_text}>
                                      <img
                                        src={fx}
                                        style={{ maxWidth: "1.5rem" }}
                                        className="mr-1 cursor-pointer"
                                        alt="fx"
                                      />
                                    </Tooltip>
                                  )}
                                </>
                              )}
                            </div>
                            {/* <Progress
                    percent={el?.Reach}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                    /> */}
                          </div>
                          <div style={{ width: "25%" }}>
                            {el?.impression_fx ? (
                              <Tooltip title="Estimated Impression">
                                <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                                  {" "}
                                  {PdfDownloadStatus
                                    ? "Est. Impr."
                                    : "Est. Impression"}
                                </div>
                              </Tooltip>
                            ) : (
                              <div className="text_regular text-grayLight white-space-nowrap">
                                Impression
                              </div>
                            )}
                            <div
                              className={`${
                                PdfDownloadStatus ? "" : "font-size18"
                              } text_heading-Rubik line-height-normal`}
                            >
                              {PdfDownloadStatus ? (
                                <>
                                  <div>
                                    {kFormatter(el?.Impression, false, true)}
                                    {el?.impression_fx && (
                                      <Tooltip title={el?.Impression_text}>
                                        <img
                                          src={fx}
                                          style={{ maxWidth: "1.5rem" }}
                                          className="mr-1 cursor-pointer"
                                          alt="fx"
                                        />
                                      </Tooltip>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>
                                    {kFormatter(el?.Impression, false, true)}
                                  </div>
                                  {el?.impression_fx && (
                                    <Tooltip title={el?.Impression_text}>
                                      <img
                                        src={fx}
                                        style={{ maxWidth: "1.5rem" }}
                                        className="mr-1 cursor-pointer"
                                        alt="fx"
                                      />
                                    </Tooltip>
                                  )}
                                </>
                              )}
                            </div>
                            {/* <Progress
                    percent={el?.Impression}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                   /> */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            {/* </StackGrid> */}
          </div>
        </>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center w-100"
          style={{ minHeight: "calc(100vh - 21.3rem)" }}
        >
          <div className="text-center">
            <img
              alt="no data"
              src={
                authParams?.theme_type === "1" ? NoDataImg : somethingWentWrong
              }
              style={{ maxWidth: "100%", minWidth: "15rem" }}
            />
            <p className="mt-15 text_regular-gray">No Data Found</p>
          </div>
        </div>
      )}

      <PaginationComponent
        data={data}
        filterPills={filterPills}
        totalPageNo={totalPageNo}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        mentionPage={mentionPage}
        pagination={pagination}
        deepDive={deepDive}
        isPreviewState={isPreviewState}
        dashboard={dashboard}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        widget_id={widget_id}
        chart_type={chart_type}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
      <PostCardDetails
        data={data}
        modalData={modalData}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setIsModalData={setIsModalData}
        isModalLoader={isModalLoader}
        setIsModalLoader={setIsModalLoader}
        widget_index={widget_index}
        section_index={section_index}
        highlightWord={highlightWord}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
    </>
  );
};

export default React.memo(PostCard, isEqual);
